import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { botonPrimario, c, tarjeta } from '../theme';
import { Icono } from './ui';

/**
 * Avisa que hay una versión nueva desplegada, para recargar.
 *
 * Una pestaña abierta sigue con el JavaScript con que se abrió aunque el
 * servidor ya tenga otro: pantallas viejas contra una API nueva. Cada build
 * nombra su script con el hash de su contenido (`/assets/index-XXXX.js`), así
 * que alcanza con pedir el index y ver si el script es otro. Se mira cada
 * minuto y al volver a la pestaña. En desarrollo no hay build: no se mira.
 */
const scriptDe = (html: string) => html.match(/<script[^>]+type="module"[^>]+src="([^"]+)"/)?.[1] ?? null;

export default function AvisoVersion() {
  const [nueva, setNueva] = useState(false);

  useEffect(() => {
    if (!import.meta.env.PROD) return;
    const actual = document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.getAttribute('src');
    if (!actual) return;
    const mirar = async () => {
      try {
        const r = await fetch('/', { cache: 'no-store' });
        const otro = scriptDe(await r.text());
        if (otro && otro !== actual) setNueva(true);
      } catch {
        // Sin red no hay nada que avisar: se vuelve a mirar en un rato.
      }
    };
    const alVolver = () => document.visibilityState === 'visible' && void mirar();
    const cada = window.setInterval(mirar, 60_000);
    document.addEventListener('visibilitychange', alVolver);
    return () => {
      window.clearInterval(cada);
      document.removeEventListener('visibilitychange', alVolver);
    };
  }, []);

  return (
    <AnimatePresence>
      {nueva && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          role="status"
          style={{
            ...tarjeta,
            position: 'fixed',
            left: 16,
            right: 16,
            bottom: 16,
            margin: '0 auto',
            maxWidth: 520,
            zIndex: 1000,
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            flexWrap: 'wrap',
            border: `1px solid ${c.verde}`,
            boxShadow: '0 8px 28px rgba(0,0,0,0.18)',
          }}
        >
          <Icono nombre="system_update" size={22} color={c.verde} />
          <span style={{ flex: 1, minWidth: 200, fontSize: 13.5, color: c.texto }}>
            Hay una versión nueva del sistema. Actualizá la página para usarla.
          </span>
          <button type="button" onClick={() => window.location.reload()} style={{ ...botonPrimario, padding: '8px 16px' }}>
            Actualizar
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
